import { render, staticRenderFns } from "./FilterReleaseYear.vue?vue&type=template&id=4e21be95"
import script from "./FilterReleaseYear.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterReleaseYear.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports